import * as React from "react";
import {useContext, useMemo} from "react";
import {ConfigContext} from "../../../../context/ConfigContext";
import {QueuedEvent, ScriptErrorLogEntry} from "../../../../../../generated/api";
import Notifications from 'react-notify-toast';
import {Message, MessageContent, MessageHeader, Tab} from "semantic-ui-react";
import {ExportSimTransportOrderEditor} from "./ExportSimTransportOrderEditor";
import {ExportSimQueuedEventEditor} from "./ExportSimQueuedEventEditor";
import {LTab} from "../../../../../util/LTab";
import {workingConfig} from "../../../configChange/ConfigSignal";
import {signal} from "@preact/signals-react";
import {resetOutputs, sendEvent, sendEventToConverter} from "../Converter";
import TabEditConfigMenu from "../../../docViewer/edi/EdiDocViewerOutputTabView";

export const exportSimOutputs = signal<string[]>([]);
export const exportSimInputIds = signal<string[]>([]);
export const exportSimOutputIndex = signal<number>(0);
export const exportSimErrors = signal<string[]>([]);

export function getCurrentExportSimOutput(): string {
    return exportSimOutputs.value[exportSimOutputIndex.value] ?? "";
}

export interface ExportSimPrepareSideProps {
    auth: any,

    beforeSend(xRequestId: string): void

    onSend(
        response: any,
        queuedEvent: QueuedEvent,
        respondedConfig: any,
        encoding: string,
        logEntry?: ScriptErrorLogEntry
    ): void
}

export function ExportSimPrepareSide(props: React.PropsWithChildren<ExportSimPrepareSideProps>) {

    const context = useContext(ConfigContext)
    const [errorMessages, setErrorMessages] = React.useState<{ inputId: string, errorMessages: string }[]>([])

    const panes = useMemo(() => [
        {
            pane: null,
            menuItem: 'TransportOrder',
            render: () => <Tab.Pane><ExportSimTransportOrderEditor
                sendEvent={sendEvent}
                beforeSend={props.beforeSend}
                onSend={props.onSend}
            /></Tab.Pane>
        },
        {
            pane: null,
            menuItem: 'Queued Event',
            render: () => <Tab.Pane>
                <ExportSimQueuedEventEditor
                    triggerQueuedEventDirectly={async (queuedEvents: QueuedEvent[]) => {

                        resetOutputs()
                        let errorPromises: { inputId: string, errorMessage: Promise<string> }[] = []
                        let promises = queuedEvents.map(queuedEvent => {
                            exportSimInputIds.value.push(queuedEvent._id)
                            errorPromises.push({
                                inputId: queuedEvent._id,
                                errorMessage: sendEventToConverter(
                                    context,
                                    queuedEvent,
                                    JSON.parse(workingConfig.value),
                                    props.onSend,
                                    props.beforeSend
                                )
                            })
                        })
                        await Promise.all(promises)
                        await Promise.all(errorPromises.map(ep => ep.errorMessage))
                        let errors: { inputId: string, errorMessages: string }[] = []
                        for (let ep of errorPromises) {
                            let errMsg = await ep.errorMessage
                            if (errMsg && errMsg.length > 0) {
                                errors.push({inputId: ep.inputId, errorMessages: errMsg})
                            }
                        }
                        setErrorMessages(errors)
                    }
                    }

                />
            </Tab.Pane>
        },
        {
            pane: null,
            menuItem: 'Config',
            render: () => <Tab.Pane>
                <TabEditConfigMenu
                    currentCompanyConfig={workingConfig.value}
                    auth={props.auth}
                    fieldPathDispatcher={() => {
                    }}
                    context={context}
                    jsonValidation={() => {
                    }}
                /></Tab.Pane>
        },
    ], [context, props.auth, props.beforeSend, props.onSend])

    function getCurrentErrorMessage(): string {
        let em = errorMessages.find(em => em.inputId === exportSimInputIds.value[exportSimOutputIndex.value])
        return em ? em.errorMessages : ""
    }

    return <div className={"flex3"}>
        {getCurrentErrorMessage() != "" &&
            <Message error>
                <MessageHeader>Error:</MessageHeader>
                <MessageContent>{getCurrentErrorMessage()}</MessageContent>
            </Message>
        }
        <LTab name={"exportSimPreEditTab"} panes={panes}/>

        <Notifications/>
    </div>

}